import ReactSelect from 'react-select';

import { shade, transparentize } from 'polished';
import styled, { css } from 'styled-components';

import { StatusType } from './index';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;

  > .form-container {
    display: flex;
    margin-bottom: 3rem;

    > svg {
      margin-top: 2.35rem;
      margin-right: 2rem;
      width: 36px;
    }

    @media (max-width: 992px) {
      display: block;

      > svg {
        display: none;
      }
    }
  }
`;

export const InputGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;

  .select-field {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    /* justify-content: center; */
    width: 100%;

    .react-select__control {
      display: flex;
      min-width: 150px;
      padding: 0.4rem;
    overflow-y: hidden;

    }
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 0px;
    height: auto;
  }
`;

export const ActionsForm = styled.div`
  width: 34%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.3rem;
  margin-left: 2rem;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-top: unset;
    margin-left: unset;
  }
`;

// Table

export const TableContainer = styled.section`
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 2rem auto;
    /* pointer-events: none; */

    tr {
      &:nth-of-type(odd) {
        background: #f3f3f3;
      }

      &:hover {
        color: #166649;
      }

      &:last-child {
        border-bottom: 2px solid #166649;
      }
    }

    th {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      padding: 1.3rem 0.75rem;
      text-align: left;
      font-weight: 500;
      border: 1px solid #166649;
    }

    td {
      padding: 0rem 0.75rem;
      text-align: left;
      font-size: 16px;
      height: 5rem;
    }

    @media (max-width: 992px) {
      width: 100%;

      table,
      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        border: 1px solid #ccc;
      }

      td {
        border: none;
        border-bottom: 1px solid #eee;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      td:before {
        padding-right: 10px;
        content: attr(data-column);
        color: #000;
        font-weight: bold;
      }
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PaginationButton = styled.div`
  display: flex;
`;

interface PGProps {
  isSelect?: boolean;
}

export const PaginationItem = styled.button<PGProps>`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 35px;
  width: 35px;
  border: 1px solid #eceeef;
  color: #979797;
  display: flex;
  margin: 0px 5px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  transition: 0.3s ease-in-out;
  background: transparent;

  svg {
    width: 18px;
  }

  :hover {
    color: ${props => props.theme.secondaryColor};
    border: 1px solid ${props => props.theme.secondaryColor};
  }

  :disabled {
    cursor: not-allowed;

    :hover {
      background: transparent;
      color: #979797;
      border: 1px solid #eceeef;
    }
  }
`;

export const FooterTable = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const PageSize = styled.div`
  display: flex;
  align-items: center;
`;

export const OrderContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  button {
    align-items: center;
    display: flex;
    font-size: 20px;
    margin-left: 0.3rem;
    background: transparent;
    color: #fff;
    transition: 0.3s ease-in-out;

    &:hover {
      color: ${transparentize(0.2, '#fff')};
    }
  }
`;

export const LoadingData = styled.div`
  width: 100%;
  margin: 2rem 12px;
`;

interface BadgeProps {
  onClick?:
    | ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void)
    | undefined;
  type?: StatusType
}

const messageColors = {
  SUCESSO: '#00de9f',
  ERRO: '#910F2D',
  PENDENTE: '#F7D56D',
  PROCESSANDO: '#B89E51',
  DEFAULT: '#c4c4c4',
};

export const Badge = styled.span<BadgeProps>`
  position: relative;
  background: ${({ type }: BadgeProps) =>
    `${transparentize(0.8, messageColors[type || StatusType.Default])}`};
  color: ${({ type }: BadgeProps) =>
    `${shade(0.2, messageColors[type || StatusType.Default])}`};
  padding: 0.3rem 0.8rem;
  font-size: 14px;
  border-radius: 0.35rem;
  /* pointer-events: none; */
  user-select: none;

  font-weight: 500;

  margin: 0rem 0.5rem 0rem 0rem;

  &:not(:first-child) {
    margin: 0rem 0.5rem;
  }

  ${({ type }: BadgeProps) =>
    type === StatusType.Erro &&
    css`
      border: 1px solid #910f2d;
      cursor: pointer;
    `}
`;

export const BadgeError = styled.span<BadgeProps>`
  position: relative;
  background: ${({ type }: BadgeProps) =>
    `${transparentize(0.8, messageColors[type || StatusType.Default])}`};
  color: ${({ type }: BadgeProps) =>
    `${shade(0.2, messageColors[type || StatusType.Default])}`};
  padding: 0.3rem 0.8rem;
  font-size: 14px;
  border-radius: 0.35rem;
  user-select: none;
  font-weight: 500;
  margin: 0rem 0.5rem 0rem 0rem;
  &:not(:first-child) {
    margin: 0rem 0.5rem;
  }
`;

export const ReactSelectCustom = styled(ReactSelect)`
  margin-left: 1rem;
  width: 80px;

  .react-select__option {
    background: #fff;
  }

  .react-select__value-container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden !important;

    .react-select__single-value {
      color: ${props => props.theme.textColor};
    }
  }

  .react-select__control {
    &:hover,
    &:active,
    &:visited,
    &:focus-visible,
    &:focus-within,
    &:focus {
      border: 1px solid ${props => props.theme.secondaryColor};
      box-shadow: none;
    }
  }

  .react-select__option {
    background: #fff;
    color: ${props => props.theme.textColor};
    display: flex;
    align-items: center;

    &:hover {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      fill: #fff;
    }

    &:hover svg {
      color: #fff;
      fill: #fff;
    }
  }

  .react-select__single-value {
    display: flex;
    align-items: center;
  }
`;

export const List = styled.ul`
  margin: 2rem 0rem;
  .list-content-secondary {
    color: #000;
    margin-bottom: 1rem;
    background: ${transparentize(0.8, '#910f2d')};
    border-left: 0.5rem solid ${props => props.theme.error};
    padding: 0.2rem;
  }
  li {
    position: relative;
    margin-bottom: 1rem;
    padding-left: 1.3rem;

    b {
      color: #000;
    }
    .list-content-principal {
      color: ${props => props.theme.error};
      font-size: 0.8rem;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      height: 1rem;
      width: 1rem;
      background: ${props => props.theme.primaryColor};
      border-radius: 50%;
    }

    &:after {
      content: '';
      position: absolute;
      left: 3px;
      top: 5px;
      height: 10px;
      width: 10px;
      background: #fff;
      border-radius: 50%;
    }
  }
`;
